// HeaderOuter.js

import React, { useState } from "react";

import { Link } from "react-router-dom";

import { func } from "prop-types";

import {
  Grid,
  Hidden,
  IconButton,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import MenuIcon from "@material-ui/icons/Menu";

import DesktopHeaderOuter from "./DesktopHeaderOuter";

import CircularProgresss from "views/components/CircularProgress/CircularProgress";

import brandTheme from "brandTheme/Theme";

import logo from "../../../assets/img/headerLogo.jpeg";

const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent:
        "space-between",
      backgroundColor:
        brandTheme.headerBackGroundColor,
      width: "100%",
      height: "80px",
      padding: "0 56px",
      boxSizing: "border-box",
       [theme.breakpoints.down("sm")]:
        {
          padding: "0px 16px",
        },
    },

    leftSection: {
      display: "flex",
      alignItems: "center",
    },

    rightSection: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },

    logoContainer: {
      display:'flex',
      alignItems:'center',
      height:'100%',
      
      // [theme.breakpoints.down("sm")]:
      //   {
      //     paddingTop:'10px',
      //   },
    },
    logo: {
      height: "60px",
      width: "auto",

      [theme.breakpoints.down("sm")]:
        {
          height: "50px",
        },
    },

    mobileContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "8px",
      width: "100%",
    },

    menuButton: {
      color: "#000",
    },
  })
);

const HeaderOuter = ({
  handleDrawerToggle,
  userDetailData,
}) => {
  const classes = useStyles();

  const [callInProgress] =
    useState(false);

  return (
    <>
      <Grid
        container
        className={classes.container}
      >
        {/* LEFT */}
        <Grid
          item
          xs={8}
          sm={6}
          className={
            classes.leftSection
          }
        >
          <Link to="/welcome"  className={classes.logoContainer}>
            <img
              src={logo}
              alt="Logo"
              className={classes.logo}
            />
          </Link>
        </Grid>

        {/* RIGHT */}
        <Grid
          item
          xs={4}
          sm={6}
          className={
            classes.rightSection
          }
        >
          {/* DESKTOP */}
          <Hidden
            smDown
            implementation="css"
          >
            <DesktopHeaderOuter
              userDetailData={
                userDetailData
              }
            />
          </Hidden>

          {/* MOBILE */}
          <Hidden
            mdUp
            implementation="css"
          >
            <div
              className={
                classes.mobileContainer
              }
            >
              <DesktopHeaderOuter
                userDetailData={
                  userDetailData
                }
                mobileView
              />

              <IconButton
                edge="end"
                className={
                  classes.menuButton
                }
                onClick={
                  handleDrawerToggle
                }
              >
                <MenuIcon />
              </IconButton>
            </div>
          </Hidden>
        </Grid>
      </Grid>

      {callInProgress && (
        <CircularProgresss
          callInProgress={
            callInProgress
          }
        />
      )}
    </>
  );
};

HeaderOuter.propTypes = {
  handleDrawerToggle:
    func.isRequired,
};

export default HeaderOuter;